// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2iIEt","loaderOuter":"PageOverlayLoader_loaderOuter__3gWNh"};